import { filterParams } from '../assets/helpers/funciones';
import { authInstance } from './axios';

let url = process.env.REACT_APP_API_URL;

export const activationDaysConfigService = {
  getConfigByDate: async (date) => {
    const response = await authInstance
      .get(`${url}/activationDaysConfig/date/${date}`)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });

    return response;
  },

  getHistory: async (params) => {
    const response = await authInstance
      .get(
        `${url}/activationDaysConfig/history?` +
          new URLSearchParams(filterParams(params))
      )
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });

    return response;
  },

  createConfig: async (data) => {
    const response = await authInstance
      .post(`${url}/activationDaysConfig/create`, data)
      .then(async (response) => {
        return response;
      })
      .catch(function (error) {
        console.log('error', error);
        error.data = [];
        return error;
      });

    return response;
  },
};
